<template>
    <div class="wrap-input">
        <label class="label"
               :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}">
               {{inputLbl.label}} <span v-if="this.inputLbl.required">*</span>
        </label>
        <div v-if="isTitle" class="gender-col">
            <div class="gender-radio"
                @click="clickTitle('นาย')">
                <span :class="[{'ic-active': content == 'นาย'}, 'gender-radio-ic']"></span>
                <div class="gender-radio-lbl">{{inputLbl.mr.label}}</div>
            </div>
            <div class="gender-radio"
                @click="clickTitle('นาง')">
                <span :class="[{'ic-active': content == 'นาง'}, 'gender-radio-ic']"></span>
                <div class="gender-radio-lbl">{{inputLbl.mrs.label}}</div>
            </div>
            <div class="gender-radio"
                @click="clickTitle('นางสาว')">
                <span :class="[{'ic-active': content == 'นางสาว'}, 'gender-radio-ic']"></span>
                <div class="gender-radio-lbl">{{inputLbl.miss.label}}</div>
            </div>
        </div>
        <div v-if="isGender" class="gender-col">
            <div class="gender-radio"
                @click="clickGender('ชาย')">
                <span :class="[{'ic-active': content == 'ชาย'}, 'gender-radio-ic']"></span>
                <div class="gender-radio-lbl">{{inputLbl.male.label}}</div>
            </div>
            <div class="gender-radio"
                @click="clickGender('หญิง')">
                <span :class="[{'ic-active': content == 'หญิง'}, 'gender-radio-ic']"></span>
                <div class="gender-radio-lbl">{{inputLbl.female.label}}</div>
            </div>
            <div class="gender-radio"
                @click="clickGender('อื่นๆ')">
                <span :class="[{'ic-active': content == 'อื่นๆ'}, 'gender-radio-ic']"></span>
                <div class="gender-radio-lbl">{{inputLbl.other.label}}</div>
            </div>
        </div>
        <div class="error-text"
             v-if="isShowErrorLbl"
             v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
export default {
    name: 'GenderRadio',
    props: {
        //v-model
        value: String,
        //props
        inputId: String,
        inputLbl: Object,
        //errInfo
        errorInfo: Object,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        isGender: Boolean,
        isTitle: Boolean,
    },
    data: function () {
        return {
            content: this.value,
        };
    },
    created: function () {
        this.initialValidate();
    },
    methods: {
        //evnet
        clickTitle: function (type) {
            this.content = type;
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            this.$emit('input', this.content);
        },
        clickGender: function (type) {
            this.content = type;
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            let gender = type == 'ชาย' ? 'male' : type == 'หญิง' ? 'female' : 'other';
            this.$emit('input', gender);
        },
        initialValidate: function () {
            if (!this.content) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
            } else {
                this.errorInfo.isValid = true;
                this.errorInfo.msg = '';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
#gender_radio{
    .gender-lbl {
        color: $bright-gray;
        font-size: 1.1rem;
        margin-bottom: 8px;

        span{
            color: $red;
        }
    }

    .gender-col {
        display: flex;
        margin-left: 10px;
        margin-bottom: -10px;
        
        .gender-radio {
            flex: 0 0 calc(100% / 3);
            width: calc(100% / 3);

            position: relative;
            margin: {
                top: auto;
                bottom: auto;
            };

            .gender-radio-ic {
                position: absolute;
                top: 50%;
                left: 0;
                width: 18px;
                height: 18px;
                background-image: url('../../assets/icon/regis_iconradio_inactive@2x.png');
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                transform: translateY(-50%);

                &.ic-active {
                    background-image: url('../../assets/icon/regis_iconradio_active@2x.png');
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }
            }

            .gender-radio-lbl {
                color: $label-gray;
                margin-left: 15px;
                padding-left: 15px;
                //font
                font-size: 1.125rem;

                @include mini-mobile(){
                    margin-left: 12px;
                    padding-left: 12px;
                }
            }
        }
    }
}
</style>
